import PropTypes from 'prop-types';

import Button from '@zenbusiness/zui/Button';

import * as Styled from './MessageWithCTA.style';
import Message from '../Message';
import { CLICKSTREAM_COMMON_PROPS, CTA_TEXT_TO_CLICKSTREAM_ELEMENT } from '../utils/constants';
import { highlightText } from '../utils/highlightText';

/**
 * A component for displaying message blocks with a CTA button at the bottom
 * @param {object} props - Component props
 * @param {string} props.message - The message text to display (used for title)
 * @param {string} props.title - The title of the message
 * @param {string} props.description - The description text
 * @param {string} props.ctaText - The text for the CTA button
 * @param {string} [props.ctaUrl] - The URL for the CTA button
 * @param {string} [props.type='primary'] - The type/color of message for styling
 * @param {string} [props.size='sm'] - The size of the message text
 * @param {string} [props.variant='card'] - The variant for styling (plain or card)
 */

function MessageWithCTA({
  message,
  ctaText,
  ctaUrl,
  type = 'primary',
  size = 'md',
  variant = 'card'
}) {
  // const navigate = useNavigate();
  // const handleCTAClick = () => {
  //   console.log('[MessageWithCTA] CTA clicked:', {
  //     ctaUrl,
  //     ctaText
  //   });
  //   if (ctaUrl) {
  //     navigate(ctaUrl, {
  //       replace: true
  //     });
  //   }
  // };

  return (
    <Styled.MessageRoot variant={variant}>
      <Message message={message} size={size} type={type} variant="plain" />

      {ctaText && (
        <Styled.ButtonContainer>
          <Button
            clickstreamProps={{
              ...CLICKSTREAM_COMMON_PROPS,
              elementName: CTA_TEXT_TO_CLICKSTREAM_ELEMENT[ctaText.toLowerCase()],
              elementText: ctaText
            }}
            color="primary"
            fullWidth
            href={ctaUrl}
            size="small"
            variant="contained"
            // onClick={handleCTAClick}
          >
            {highlightText(ctaText, Styled.TextHighlight)}
            <Styled.ArrowForwardIcon />
          </Button>
        </Styled.ButtonContainer>
      )}
    </Styled.MessageRoot>
  );
}

MessageWithCTA.propTypes = {
  message: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'secondary', 'info', 'warning', 'error', 'success']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl']),
  variant: PropTypes.oneOf(['plain', 'card'])
};

export default MessageWithCTA;
